import { gtm } from 'src/libs/gtm';
import { useMountEffect } from './use-mount-effect';

export const usePageView = (): void => {
  useMountEffect(() => {
    gtm.push({ event: 'page_view' });
  });
};
